module.exports = __webpack_public_path__ + "static/img/profile.a64eb58f.png";